<template>
  <div>
    <myHeader></myHeader>
    <div class="web-body">
      <div class="icp">
        <img class="img-responsive" alt="Responsive image" :src="img" id="banner">
      </div>

    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>

import myFooter from './myFooter';
import myHeader from './myHeader';

export default {
  name: "icp",
  components: {
    'myHeader': myHeader,
    'myFooter': myFooter
  },
  data() {
    return {
      img: require('../assets/images/增值电信许可证.jpg')
    }
  }
}
</script>

<style scoped>
.icp {
  background: #fff;
}

.img-responsive {
  width: 400px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/icp.vue